import { useMemo } from 'react';
import { getTerminalMode } from 'utils/terminal';

export const useIsTerminalMode = () => {
  const isTerminalMode = useMemo(() => {
    return getTerminalMode();
  }, []);

  return { isTerminalMode };
};
